import { render, staticRenderFns } from "./AnalyticsRatings.vue?vue&type=template&id=68e8e4ee&scoped=true"
import script from "./AnalyticsRatings.vue?vue&type=script&lang=js"
export * from "./AnalyticsRatings.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsRatings.vue?vue&type=style&index=0&id=68e8e4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e8e4ee",
  null
  
)

export default component.exports